import {
  FilterBarField,
  SelectedFilterField,
} from '@cdw-ae/filter-bar-interfaces';
import {
  NavigationConfig,
  UrlStateConfig,
  UrlStateItem,
} from '@cdw-ae/url-params';
export interface FilterState {
  filterBars: { [filterBarId: string]: SelectedFilterField[] };
  /**
   * Per-filter-bar content-addressed snapshot reference (EDUS-2575). Present iff
   * the bar's current filters overflow the inline URL budget — derived state,
   * (re)set by the data-fetch path on overflow and from the URL on restore,
   * cleared when filters change back under the budget. The URL-sync effect reads
   * it so the address bar and the grid query never disagree.
   */
  filterSnapshotRefs: { [filterBarId: string]: string | null };
  routeConfig: {
    filterBarSettings: FilterBarField[] | null;
    urlParamConfig: UrlStateConfig | null;
    navigationConfig: NavigationConfig<UrlStateItem>[] | null;
  };
  isLoading: boolean;
}

export const initialFilterState: FilterState = {
  filterBars: {},
  filterSnapshotRefs: {},
  routeConfig: {
    filterBarSettings: null,
    urlParamConfig: null,
    navigationConfig: null,
  },
  isLoading: false,
};
